export default __webpack_public_path__ + "static/media/twitter.2f44bd72.svg";